import { BaseOptionType } from 'antd/lib/select';
import { CSSProperties, ReactNode } from 'react';

export type BaseFormItemProps<T> = {
  onChange?: (value: T) => void;
  value?: T;
  defaultValue?: T;
};

export type PropsWithStyles<T> = T & {
  style?: CSSProperties;
  className?: string;
};

export const TDS_SEARCH_VALUES = 'search_value_storage_3';

/**
 * 保存检索记录协议（localStorage）
 * - 单模式：仅使用 values
 * - 对比模式：使用 values（A）+ compareValues（B），并通过 isCompare 区分
 *
 * 注意：为避免 proto 依赖，这里 filters 使用 any[]（仅用于持久化/恢复时生成 token 或直传）
 */
export type TdsSearchValue = {
  id: string;
  name: string;
  /**
   * 是否为对比模式记录
   */
  isCompare?: boolean;
  /**
   * 单模式 values，或对比模式下 A 的 values
   */
  values: Record<string, any>;
  /**
   * 单模式 filters（可选）
   */
  filters?: any[];
  /**
   * 对比模式下 B 的 values（可选）
   */
  compareValues?: Record<string, any>;
  /**
   * 对比模式下 B 的 filters（可选）
   */
  compareFilters?: any[];
  timestamp?: number;
};

export type TdsSearchValueStorageType = TdsSearchValue[];


export interface OptionType extends BaseOptionType {
  label: ReactNode;
  value?: string | number | null;
}

export enum TdsColumnGroup {
  UserInfo = 'userInfo',
  ApplicationInfo = 'applicationInfo',
  DeviceInfo = 'deviceinfo',
  ContextInfo = 'contextInfo',
  exceptionInfo = 'exceptionInfo',
  Tag = 'tag',
  Custom = 'custom',
  RequestInfo = 'requestInfo',
}
